import moment from 'moment';
import React from 'react';
import { FormGroup, Label } from 'reactstrap';

const CreatePolled = ({ setPollData, pollData, pollErrors, setPollErrors }) => {
  const ITEMS_LIMIT = 20;

  const handleOptionChange = (e, index) => {
    setPollErrors(null);
    const newOptions = [...pollData?.options];
    newOptions[index] = e.target.value;
    setPollData({
      ...pollData,
      options: newOptions,
    });
  };

  const addOption = () => {
    setPollData({
      ...pollData,
      options: [...pollData?.options, ''],
    });
  };

  const removeOption = (index) => {
    const newOptions = pollData?.options.filter((_, i) => i !== index);
    setPollData({
      ...pollData,
      options: newOptions,
    });
  };

  return (
    <>
      <h5 className="mb-4 pb-3 border-bottom">Poll Details</h5>

      <FormGroup className="mb-4">
        <Label for="pollTitle" className="form-label  ">
          Title <span className="text-danger">*</span>
        </Label>
        <input
          id="pollTitle"
          type="text"
          value={pollData?.title}
          onChange={(e) => {
            setPollErrors(null);
            setPollData({
              ...pollData,
              title: e.target.value,
            });
          }}
          className="form-control"
          placeholder="Enter poll title"
        />

        {(pollErrors?.title || pollErrors?.customTitle) && (
          <div className="text-danger mt-2">{pollErrors?.title || pollErrors?.customTitle}</div>
        )}
      </FormGroup>

      <FormGroup className="mb-4">
        <Label for="endDate" className="form-label  ">
          End Date <span className="text-danger">*</span>
        </Label>
        <input
          id="endDate"
          type="datetime-local"
          min={moment().format('YYYY-MM-DDTHH:mm')}
          value={pollData?.endDate ? moment.utc(pollData.endDate).format('YYYY-MM-DDTHH:mm') : null}
          onChange={(e) => {
            setPollErrors(null);
            setPollData({
              ...pollData,
              endDate: e.target.value,
            });
          }}
          className="form-control"
          placeholder="Enter poll end date"
        />
        {pollErrors?.endDate && <div className="text-danger mt-2">{pollErrors?.endDate}</div>}
      </FormGroup>

      <FormGroup className={`mb-3`}>
        <Label className="mb-3">Allow Multiple Answers</Label>
        <div className="d-flex align-items-center">
          {[true, false].map((option, i) => (
            <div key={`allowMultiple_${i}`} className="form-check mb-3 d-inline-block me-4">
              <input
                type="radio"
                id={`allowMultiple_${option}`}
                name="allowMultiple"
                className="form-check-input"
                checked={pollData?.allowMultiple === option}
                onChange={() => {
                  setPollErrors(null);
                  setPollData({
                    ...pollData,
                    allowMultiple: option,
                  });
                }}
              />
              <label className="form-check-label" htmlFor={`allowMultiple_${option}`}>
                {option ? 'Yes' : 'No'}
              </label>
            </div>
          ))}
        </div>
      </FormGroup>

      <FormGroup className={`mb-3`}>
        <Label className="mb-3">
          Options <span className="text-danger">*</span>
        </Label>
        <div className="flex flex-col bg-light p-4 rounded-2">
          {/* Poll Options */}
          {pollData?.options?.map((option, index) => (
            <div key={`poll_${index}`} className="d-flex align-items-center mb-4">
              <span className="fs-5 me-4">{index + 1}.</span>
              <input
                type="text"
                value={option}
                onChange={(e) => handleOptionChange(e, index)}
                className="form-control"
                placeholder={`Choice ${index + 1}`}
              />
              <button type="button" onClick={() => removeOption(index)} className="ms-4 btn btn-outline-danger">
                Remove
              </button>
            </div>
          ))}

          {pollData?.options?.length < ITEMS_LIMIT ? (
            <>
              <hr className="mt-2" />
              <div className="text-start">
                <button type="button" onClick={addOption} className="btn btn-success">
                  Add Item +
                </button>
              </div>
            </>
          ) : (
            <div className="my-0"></div>
          )}
        </div>
        {pollErrors?.options && <div className="text-danger mt-2">{pollErrors?.options}</div>}
      </FormGroup>
    </>
  );
};

export default CreatePolled;
